import {Component, EventEmitter, Inject, Input, Optional, Output, ViewChild} from '@angular/core';
import {ControlValueAccessor, DefaultValueAccessor, FormBuilder, FormControl, FormGroup, NG_ASYNC_VALIDATORS, NG_VALIDATORS, NG_VALUE_ACCESSOR, NgModel} from '@angular/forms';
import {animations} from '../../controls';

declare var $: any;

@Component({
    selector: 'itpx-happy-autocomplete',
    templateUrl: './happy-autocomplete.component.html',
    styleUrls: ['../styles.css','./happy-autocomplete.component.css'],
    animations,
    providers: [{
        provide: NG_VALUE_ACCESSOR,
        useExisting: HappyAutocompleteComponent,
        multi: true,
    }]
})
export class HappyAutocompleteComponent implements ControlValueAccessor {
    form: FormGroup;
    @Input() public placeholder: string;
    @Input() public reverse: boolean;
    @Input() public source: any;
    @Input() public disabled: boolean;
    @Input() name: string = 'values';
    @Input() type: string = 'text';
    @Input() createNewProposal: boolean = false;
    @Input() required = true;
    @Input() autonomous = true;
    @Input() autofocus = false;
    @Input() resetOnEmit: boolean = true;
    @Output() selection = new EventEmitter<any>();
    private innerValue: string[] = [];
    private $autocomplete: any;
    readonly INPUT: string = 'input';
    @ViewChild('autocomplete') autocomplete;
    @ViewChild(DefaultValueAccessor) private valueAccessor: DefaultValueAccessor;


    constructor(
        @Optional() @Inject(NG_VALIDATORS) validators: Array<any>,
        @Optional() @Inject(NG_ASYNC_VALIDATORS) asyncValidators: Array<any>,
        private fb: FormBuilder
    ) {
    }

    ngOnInit() {
        this.form = this.fb.group({
            [this.INPUT]: []
        })
    }

    ngAfterViewInit() {
        let self = this;
        this.$autocomplete = $(this.autocomplete.nativeElement)
            .autocomplete({
                source: self.source,
                minLength: 0,
                maxLength: 1,
                autoFocus: true,
                response: (event, ui) => {
                    const val = this.$autocomplete.val();
                    if (!this.createNewProposal && ui.content.length === 0) {
                        ui.content.unshift({
                            label: 'No results found...',
                            value: null,
                            id: 0
                        });
                    }
                    if (this.createNewProposal && (val && val.length >= 3) &&
                        ((this.innerValue.indexOf(val) < 0 && ui.content.length === 0) || this.showNew(ui.content, val))) {

                        ui.content.unshift({
                            label: 'Create new: ' + val,
                            value: val,
                            id: 0
                        });
                    }
                }
            })
            .on('autocompleteselect', function (event, ui) {
                let item = ui.item as SelectedHappyItem;
                self.onSelect(item.value);
                $(this).val('');
                return true;
            });
        if (this.autofocus) {
            setTimeout(() => {
                this.autocomplete.nativeElement.focus();
            }, 200);
        }
    }

    private onSelect(item: any) {
        if (!item) {
            return;
        }
        let items = this.value;
        if (items.indexOf(item) > -1) return;
        this.selection.emit(item);
        if (this.resetOnEmit) {
            setTimeout(_ => {
                this.form.get(this.INPUT).updateValueAndValidity();
                this.form.get(this.INPUT).patchValue(null);
            }, 100)
        }
    }
/*
    private onRemove(item: string) {
        let items = this.value;
        items = items.slice();
        let index = items.indexOf(item, 0);
        if (index > -1) items.splice(index, 1);
        this.value = items;
    }*/

    writeValue(obj: any) {
        this.valueAccessor.writeValue(obj);
    }

    registerOnChange(fn: any) {
        this.valueAccessor.registerOnChange(fn);
    }

    registerOnTouched(fn: any) {
        this.valueAccessor.registerOnTouched(fn);
    }

    setDisabledState(isDisabled: boolean) {
        this.valueAccessor.setDisabledState(isDisabled);
    }

    private showNew(arr: any[], key: string) {
        let result = true;
        if (this.innerValue.indexOf(key) > -1) return false;
        arr.forEach(_ => {
            if (_.value == key) {
                result = false;
                return;
            }
        });
        return result;
    }

    private changed = new Array<(value: string[]) => void>();
    private touched = new Array<() => void>();

    get value(): string[] {
        return this.innerValue;
    }

    /*set value(value: string[]) {
        if (!value || typeof value === 'string') return;
        this.innerValue = value;
        this.query = '';
        this.changed.forEach(f => f(value));
    }*/

    /*writeValue(value: string[]) {
        if (!value || typeof value === 'string') return;
        this.innerValue = value;
        this.query = '';
    }*/

    /*registerOnChange(fn: (value: string[]) => void) {
        this.changed.push(fn);
    }

    registerOnTouched(fn: () => void) {
        this.touched.push(fn);
    }*/

    touch() {
        this.touched.forEach(f => f());
    }
}
export class SelectedHappyItem {
    constructor(public value: string, public color: string) { }
}



// WEBPACK FOOTER //
// ./src/app/shared/components/happy/happy-autocomplete/happy-autocomplete.component.ts